/* CA privacy hardening (Oct 2026): every third-party tracker is loaded
   from src/components/consent.js. GTM (GA4 / Google Ads, Microsoft Ads UET) loads
   only after the visitor accepts the consent banner, or on a return
   visit with the consent cookie.
   CallRail's number swap is NOT gated (dynamic numbers drive call
   attribution) — see consent.js.
   Trackers start on onInitialClientRender, i.e. AFTER React hydration,
   so the CallRail number swap never races hydration. */
exports.onInitialClientRender = () => {
  require('./src/components/consent').loadTrackers()
}

// Logs when the client route changes
exports.onRouteUpdate = ({ location, prevLocation }) => {
  var referrer = document.referrer

  //if landing URL does not exist in local storage, set current pathname
  if (
    typeof window !== 'undefined' &&
    window.localStorage &&
    !window.localStorage.getItem('lNdUrL')
  ) {
    window.localStorage.setItem('lNdUrL', location.href)
    window.localStorage.setItem('lNdUrLDtIme', new Date())
  }

  window.localStorage.setItem('crNtPaTH', location.href)
  window.localStorage.setItem(
    'prevPaTHnAme',
    prevLocation ? prevLocation.href : null
  )

  window && window.CallTrk && window.CallTrk.swap()

  // The removed gatsby-plugin-google-tagmanager pushed this event on every
  // SPA route change; re-emit it so GTM pageview triggers keep working
  // (50ms lets the new page title settle). Harmless before consent: the
  // dataLayer is just an array until GTM loads.
  setTimeout(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'gatsby-route-change' })
  }, 50)
}

/* Consent banner on every page. Must mirror wrapPageElement in
   gatsby-ssr.js (same tree shape) or hydration mismatches appear. The
   banner renders null until after mount, so SSR output is unchanged. */
exports.wrapPageElement = ({ element }) => {
  const React = require('react')
  const ConsentBanner = require('./src/components/consent-banner').default
  return React.createElement(
    React.Fragment,
    null,
    element,
    React.createElement(ConsentBanner)
  )
}
